import React from 'react';

export const Loader = ({ className = 'h-[400px]', message }) => {
  return (
    <div className={`flex flex-col justify-center items-center ${className}`}>
      <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
      {message && <p className="text-sm text-muted-foreground mt-2">{message}</p>}
    </div>
  );
};

export default Loader;
